import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDeployButton && _vm.canSeeActionButtons)?_c(VBtn,{attrs:{"disabled":_vm.loading || _vm.isDisabled,"color":"primary","large":""},on:{"click":_vm.deploy}},[_c('span',[_vm._v(_vm._s(_vm.$t("WorkspaceEdit.deploy.buttonLabel")))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }